// CareLogix™ ORACLE — Animated Global Intelligence Feed (Phase 33 §7)
import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { PALETTE } from "@/components/animation/MotionShared";

const SAMPLE_FEED = [
  { region: "USA",       title: "Federal grant window opens for community clinics",      tag: "HRSA"        },
  { region: "EU",        title: "Predictive model favors EUR strength over JPY this wk", tag: "FX"          },
  { region: "Africa",    title: "AfDB issues call for digital health pilots",            tag: "GRANT"       },
  { region: "Asia",      title: "Singapore central bank holds rates; signal MODERATE",    tag: "MACRO"       },
  { region: "USA",       title: "FDA calendar: PDUFA dates trigger event-window agents",   tag: "HEALTHCARE"  },
  { region: "Africa",    title: "Lagos fintech corridor: 4 new startups flagged WATCH",   tag: "STARTUP"     },
  { region: "USA",       title: "Form-4 public buying spike across regional banks",       tag: "ALT-DATA"    },
  { region: "Global",    title: "Macro: G20 commodity index rotates risk-on",              tag: "MACRO"       },
  { region: "USA",       title: "NIH grant deadline 21 days — PRIORITY surge",           tag: "GRANT"       },
  { region: "UK",        title: "Wellcome Trust opens scoping window for global health",   tag: "FOUNDATION"  },
];

export default function GlobalIntelFeed({ testid = "global-intel-feed" }) {
  const [idx, setIdx] = useState(0);
  useEffect(() => {
    const id = setInterval(() => setIdx((i) => (i + 1) % SAMPLE_FEED.length), 2200);
    return () => clearInterval(id);
  }, []);
  const items = [
    SAMPLE_FEED[idx],
    SAMPLE_FEED[(idx + 1) % SAMPLE_FEED.length],
    SAMPLE_FEED[(idx + 2) % SAMPLE_FEED.length],
  ];
  return (
    <section style={S.shell} data-testid={testid} aria-label="Global Intelligence Feed">
      <header style={S.head}>
        <div style={S.eyebrow}>GLOBAL INTELLIGENCE FEED™ · LIVE</div>
        <h3 style={S.title}>Cross-domain Signal Stream</h3>
      </header>
      <ul style={S.list}>
        <AnimatePresence>
          {items.map((it) => (
            <motion.li
              key={`${idx}-${it.title}`}
              style={S.item}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -10 }}
              transition={{ duration: 0.45 }}
              data-testid={`${testid}-item`}
            >
              <span style={S.region}>{it.region}</span>
              <span style={S.body}>{it.title}</span>
              <span style={S.tag}>{it.tag}</span>
            </motion.li>
          ))}
        </AnimatePresence>
      </ul>
    </section>
  );
}

const S = {
  shell:   { background: "linear-gradient(180deg, rgba(8,32,22,0.55), rgba(4,6,8,0.85))", border: `1px solid ${PALETTE.goldGlow}`, borderRadius: 14, padding: 12, color: PALETTE.slate3, display: "flex", flexDirection: "column", gap: 8 },
  head:    { display: "flex", justifyContent: "space-between", alignItems: "baseline", gap: 8, flexWrap: "wrap" },
  eyebrow: { color: PALETTE.gold, fontFamily: "'Space Mono', monospace", fontSize: 10, letterSpacing: "0.22em" },
  title:   { margin: 0, color: PALETTE.goldBright, fontSize: 13 },
  list:    { margin: 0, padding: 0, listStyle: "none", display: "flex", flexDirection: "column", gap: 6 },
  item:    { display: "grid", gridTemplateColumns: "68px 1fr auto", alignItems: "center", gap: 8, padding: "6px 8px", background: "rgba(255,255,255,0.02)", border: "1px solid rgba(255,255,255,0.05)", borderRadius: 8 },
  region:  { color: PALETTE.gold, fontFamily: "'Space Mono', monospace", fontSize: 10, letterSpacing: "0.10em" },
  body:    { color: PALETTE.slate3, fontSize: 12.5 },
  tag:     { color: PALETTE.greenAccent, fontFamily: "'Space Mono', monospace", fontSize: 10, padding: "2px 7px", border: `1px solid ${PALETTE.greenAccent}`, borderRadius: 999 },
};
